export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

export const replaceUrl = (navigate, url, state = {}, query) => {
    let realUrl = url;
    let realQueryString = query ? `?${new URLSearchParams(query).toString()}` : '';
    if (url.includes('?') && !query) {
        const splitUrl = url.split('?');
        realUrl = splitUrl[0];
        realQueryString = `?${splitUrl[1]}`;
    }

    navigate(realUrl + realQueryString, { 
        replace: true,
        state: { backPathname: window.history.state?.backPathname, ...state }
    });
};

export const goBack = (navigate) => {
    navigate(-1);
};

export const showPermissionModal = (navigate, permission) => {
    navigate(`?permission=${permission}`);
};

export const closePermissionModal = (navigate) => {
    navigate('?');
};
